/* @flow */
import React from 'react'
import './SongProgress.css'

export type Props = {
  position: number,
  duration: number
}

const clock = (seconds: number) => {
  if (!isFinite(seconds) || seconds < 0) return '0:00'
  const s = Math.floor(seconds)
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`
}

// Read-only progress through the current track (it's a radio stream, so no seeking).
export default ({ position = 0, duration = 0 }: Props) => {
  const hasDuration = isFinite(duration) && duration > 0
  const pct = hasDuration ? Math.min(100, (position / duration) * 100) : 0
  return (
    <div className={ `song-progress${hasDuration ? '' : ' song-progress--idle'}` }>
      <span className="song-progress__time">{ clock(position) }</span>
      <div
        className="song-progress__track"
        role="progressbar"
        aria-label="Song progress"
        aria-valuemin={ 0 }
        aria-valuemax={ hasDuration ? Math.round(duration) : 0 }
        aria-valuenow={ Math.round(position) }
      >
        <div className="song-progress__fill" style={{ width: `${pct}%` }} />
      </div>
      <span className="song-progress__time">{ hasDuration ? `-${clock(duration - position)}` : '--:--' }</span>
    </div>
  )
}
